export type Rank =
  | 'Distributor' |'Brand Partner Gold' |'Brand Partner Lapis' |'Brand Partner Ruby' |'Executive' |'Provisional Executive' |'Emerald' |'Diamond' |'Blue Diamond' |'Presidential Director';

export type QualStage = 'None' | 'LOI' | 'Q1' | 'Q2' | 'Qualified';

export interface Distributor {
  id: string;
  name: string;
  email: string;
  rank: Rank;
  psv: number;
  gsv: number;
  active: boolean;
  sponsorId: string | null;
  children: string[];
  qualStage: QualStage;
  qualMonth: number; // month index in qual window
  graceMonthUsed: boolean;
  pexecMonthsRemaining: number | null;
  g1BreakawayCount: number;
  joinDate: string;
  country: string;
  commissionThisMonth: number;
  adrActive: boolean;
}

export const DISTRIBUTORS: Record<string, Distributor> = {
  'dist-001': {
    id: 'dist-001', name: 'Marcus Whitfield', email: 'marcus.w@nuskin.net',
    rank: 'Presidential Director', psv: 420, gsv: 68400, active: true,
    sponsorId: null, children: ['dist-002', 'dist-003', 'dist-004'],
    qualStage: 'Qualified', qualMonth: 0, graceMonthUsed: false,
    pexecMonthsRemaining: null, g1BreakawayCount: 3, joinDate: '2018-03-15',
    country: 'US', commissionThisMonth: 9240, adrActive: true,
  },
  'dist-002': {
    id: 'dist-002', name: 'Priya Nambiar', email: 'priya.n@nuskin.net',
    rank: 'Blue Diamond', psv: 310, gsv: 31200, active: true,
    sponsorId: 'dist-001', children: ['dist-005', 'dist-006', 'dist-007'],
    qualStage: 'Qualified', qualMonth: 0, graceMonthUsed: false,
    pexecMonthsRemaining: null, g1BreakawayCount: 2, joinDate: '2019-07-22',
    country: 'US', commissionThisMonth: 4680, adrActive: true,
  },
  'dist-003': {
    id: 'dist-003', name: 'Jerome Castillo', email: 'jerome.c@nuskin.net',
    rank: 'Diamond', psv: 280, gsv: 18700, active: true,
    sponsorId: 'dist-001', children: ['dist-008', 'dist-009'],
    qualStage: 'Qualified', qualMonth: 0, graceMonthUsed: true,
    pexecMonthsRemaining: null, g1BreakawayCount: 1, joinDate: '2020-01-10',
    country: 'US', commissionThisMonth: 2805, adrActive: true,
  },
  'dist-004': {
    id: 'dist-004', name: 'Aisha Okonkwo', email: 'aisha.o@nuskin.net',
    rank: 'Provisional Executive', psv: 115, gsv: 1850, active: true,
    sponsorId: 'dist-001', children: ['dist-010', 'dist-011'],
    qualStage: 'Qualified', qualMonth: 0, graceMonthUsed: true,
    pexecMonthsRemaining: 2, g1BreakawayCount: 0, joinDate: '2021-09-05',
    country: 'US', commissionThisMonth: 462, adrActive: true,
  },
  'dist-005': {
    id: 'dist-005', name: 'Derek Huang', email: 'derek.h@nuskin.net',
    rank: 'Emerald', psv: 350, gsv: 12400, active: true,
    sponsorId: 'dist-002', children: ['dist-012', 'dist-013', 'dist-014'],
    qualStage: 'Qualified', qualMonth: 0, graceMonthUsed: false,
    pexecMonthsRemaining: null, g1BreakawayCount: 1, joinDate: '2020-05-18',
    country: 'US', commissionThisMonth: 1736, adrActive: true,
  },
  'dist-006': {
    id: 'dist-006', name: 'Natalia Ferreira', email: 'natalia.f@nuskin.net',
    rank: 'Executive', psv: 220, gsv: 5800, active: true,
    sponsorId: 'dist-002', children: ['dist-015', 'dist-016'],
    qualStage: 'Qualified', qualMonth: 0, graceMonthUsed: false,
    pexecMonthsRemaining: null, g1BreakawayCount: 0, joinDate: '2021-02-28',
    country: 'CA', commissionThisMonth: 638, adrActive: true,
  },
  'dist-007': {
    id: 'dist-007', name: 'Kwame Asante', email: 'kwame.a@nuskin.net',
    rank: 'Brand Partner Ruby', psv: 180, gsv: 2100, active: true,
    sponsorId: 'dist-002', children: ['dist-017'],
    qualStage: 'Q2', qualMonth: 3, graceMonthUsed: false,
    pexecMonthsRemaining: null, g1BreakawayCount: 0, joinDate: '2022-06-14',
    country: 'US', commissionThisMonth: 189, adrActive: true,
  },
  'dist-008': {
    id: 'dist-008', name: 'Lena Kowalski', email: 'lena.k@nuskin.net',
    rank: 'Brand Partner Lapis', psv: 160, gsv: 1640, active: true,
    sponsorId: 'dist-003', children: ['dist-018', 'dist-019'],
    qualStage: 'Q1', qualMonth: 2, graceMonthUsed: false,
    pexecMonthsRemaining: null, g1BreakawayCount: 0, joinDate: '2022-11-03',
    country: 'US', commissionThisMonth: 147, adrActive: true,
  },
  'dist-009': {
    id: 'dist-009', name: 'Tomás Varela', email: 'tomas.v@nuskin.net',
    rank: 'Distributor', psv: 75, gsv: 340, active: false,
    sponsorId: 'dist-003', children: [],
    qualStage: 'None', qualMonth: 0, graceMonthUsed: false,
    pexecMonthsRemaining: null, g1BreakawayCount: 0, joinDate: '2023-04-20',
    country: 'US', commissionThisMonth: 0, adrActive: false,
  },
  'dist-010': {
    id: 'dist-010', name: 'Simone Okafor', email: 'simone.o@nuskin.net',
    rank: 'Brand Partner Gold', psv: 140, gsv: 680, active: true,
    sponsorId: 'dist-004', children: [],
    qualStage: 'LOI', qualMonth: 1, graceMonthUsed: false,
    pexecMonthsRemaining: null, g1BreakawayCount: 0, joinDate: '2023-08-12',
    country: 'US', commissionThisMonth: 61, adrActive: true,
  },
  'dist-011': {
    id: 'dist-011', name: 'Ryan Beaumont', email: 'ryan.b@nuskin.net',
    rank: 'Distributor', psv: 105, gsv: 210, active: true,
    sponsorId: 'dist-004', children: [],
    qualStage: 'None', qualMonth: 0, graceMonthUsed: false,
    pexecMonthsRemaining: null, g1BreakawayCount: 0, joinDate: '2023-10-01',
    country: 'US', commissionThisMonth: 0, adrActive: false,
  },
  'dist-012': {
    id: 'dist-012', name: 'Fatima Al-Rashid', email: 'fatima.ar@nuskin.net',
    rank: 'Executive', psv: 240, gsv: 4200, active: true,
    sponsorId: 'dist-005', children: ['dist-020', 'dist-021'],
    qualStage: 'Qualified', qualMonth: 0, graceMonthUsed: false,
    pexecMonthsRemaining: null, g1BreakawayCount: 0, joinDate: '2021-12-15',
    country: 'US', commissionThisMonth: 462, adrActive: true,
  },
  'dist-013': {
    id: 'dist-013', name: 'Carlos Mendes', email: 'carlos.m@nuskin.net',
    rank: 'Brand Partner Lapis', psv: 130, gsv: 890, active: true,
    sponsorId: 'dist-005', children: [],
    qualStage: 'Q1', qualMonth: 2, graceMonthUsed: false,
    pexecMonthsRemaining: null, g1BreakawayCount: 0, joinDate: '2022-09-08',
    country: 'CA', commissionThisMonth: 80, adrActive: true,
  },
  'dist-014': {
    id: 'dist-014', name: 'Ingrid Svensson', email: 'ingrid.s@nuskin.net',
    rank: 'Distributor', psv: 95, gsv: 190, active: false,
    sponsorId: 'dist-005', children: [],
    qualStage: 'None', qualMonth: 0, graceMonthUsed: false,
    pexecMonthsRemaining: null, g1BreakawayCount: 0, joinDate: '2023-06-22',
    country: 'US', commissionThisMonth: 0, adrActive: false,
  },
  'dist-015': {
    id: 'dist-015', name: 'Obinna Ezeh', email: 'obinna.e@nuskin.net',
    rank: 'Brand Partner Gold', psv: 155, gsv: 490, active: true,
    sponsorId: 'dist-006', children: [],
    qualStage: 'LOI', qualMonth: 1, graceMonthUsed: false,
    pexecMonthsRemaining: null, g1BreakawayCount: 0, joinDate: '2023-03-17',
    country: 'US', commissionThisMonth: 44, adrActive: true,
  },
  'dist-016': {
    id: 'dist-016', name: 'Yuki Tanaka', email: 'yuki.t@nuskin.net',
    rank: 'Distributor', psv: 110, gsv: 220, active: true,
    sponsorId: 'dist-006', children: [],
    qualStage: 'None', qualMonth: 0, graceMonthUsed: false,
    pexecMonthsRemaining: null, g1BreakawayCount: 0, joinDate: '2023-11-05',
    country: 'US', commissionThisMonth: 0, adrActive: false,
  },
  'dist-017': {
    id: 'dist-017', name: 'Adaeze Obi', email: 'adaeze.o@nuskin.net',
    rank: 'Distributor', psv: 120, gsv: 240, active: true,
    sponsorId: 'dist-007', children: [],
    qualStage: 'None', qualMonth: 0, graceMonthUsed: false,
    pexecMonthsRemaining: null, g1BreakawayCount: 0, joinDate: '2024-01-14',
    country: 'US', commissionThisMonth: 0, adrActive: false,
  },
  'dist-018': {
    id: 'dist-018', name: 'Pierre Dubois', email: 'pierre.d@nuskin.net',
    rank: 'Brand Partner Gold', psv: 145, gsv: 390, active: true,
    sponsorId: 'dist-008', children: [],
    qualStage: 'None', qualMonth: 0, graceMonthUsed: false,
    pexecMonthsRemaining: null, g1BreakawayCount: 0, joinDate: '2023-09-28',
    country: 'CA', commissionThisMonth: 35, adrActive: true,
  },
  'dist-019': {
    id: 'dist-019', name: 'Mei-Ling Chen', email: 'mei.c@nuskin.net',
    rank: 'Distributor', psv: 100, gsv: 100, active: true,
    sponsorId: 'dist-008', children: [],
    qualStage: 'None', qualMonth: 0, graceMonthUsed: false,
    pexecMonthsRemaining: null, g1BreakawayCount: 0, joinDate: '2024-02-08',
    country: 'US', commissionThisMonth: 0, adrActive: false,
  },
  'dist-020': {
    id: 'dist-020', name: 'Rashida James', email: 'rashida.j@nuskin.net',
    rank: 'Distributor', psv: 130, gsv: 260, active: true,
    sponsorId: 'dist-012', children: [],
    qualStage: 'None', qualMonth: 0, graceMonthUsed: false,
    pexecMonthsRemaining: null, g1BreakawayCount: 0, joinDate: '2024-03-01',
    country: 'US', commissionThisMonth: 0, adrActive: false,
  },
  'dist-021': {
    id: 'dist-021', name: 'Elias Bergström', email: 'elias.b@nuskin.net',
    rank: 'Distributor', psv: 115, gsv: 230, active: true,
    sponsorId: 'dist-012', children: [],
    qualStage: 'None', qualMonth: 0, graceMonthUsed: false,
    pexecMonthsRemaining: null, g1BreakawayCount: 0, joinDate: '2024-03-15',
    country: 'SE', commissionThisMonth: 0, adrActive: false,
  },
};

export const RANK_ORDER: Rank[] = [
  'Distributor',
  'Brand Partner Gold',
  'Brand Partner Lapis',
  'Brand Partner Ruby',
  'Executive',
  'Provisional Executive',
  'Emerald',
  'Diamond',
  'Blue Diamond',
  'Presidential Director',
];

export function getRankColor(rank: Rank): string {
  const map: Record<Rank, string> = {
    'Distributor': 'text-zinc-400',
    'Brand Partner Gold': 'text-yellow-400',
    'Brand Partner Lapis': 'text-blue-400',
    'Brand Partner Ruby': 'text-red-400',
    'Executive': 'text-purple-400',
    'Provisional Executive': 'text-orange-400',
    'Emerald': 'text-emerald-400',
    'Diamond': 'text-cyan-400',
    'Blue Diamond': 'text-violet-400',
    'Presidential Director': 'text-amber-400',
  };
  return map[rank] || 'text-zinc-400';
}

export function getRankBgColor(rank: Rank): string {
  const map: Record<Rank, string> = {
    'Distributor': 'bg-zinc-700/40 border-zinc-600/30',
    'Brand Partner Gold': 'bg-yellow-500/15 border-yellow-500/30',
    'Brand Partner Lapis': 'bg-blue-500/15 border-blue-500/30',
    'Brand Partner Ruby': 'bg-red-500/15 border-red-500/30',
    'Executive': 'bg-purple-500/15 border-purple-500/30',
    'Provisional Executive': 'bg-orange-500/15 border-orange-500/30',
    'Emerald': 'bg-emerald-500/15 border-emerald-500/30',
    'Diamond': 'bg-cyan-500/15 border-cyan-500/30',
    'Blue Diamond': 'bg-violet-500/15 border-violet-500/30',
    'Presidential Director': 'bg-amber-500/15 border-amber-500/30',
  };
  return map[rank] || 'bg-zinc-700/40 border-zinc-600/30';
}

export function getRankDotColor(rank: Rank): string {
  const map: Record<Rank, string> = {
    'Distributor': 'bg-zinc-500',
    'Brand Partner Gold': 'bg-yellow-400',
    'Brand Partner Lapis': 'bg-blue-400',
    'Brand Partner Ruby': 'bg-red-400',
    'Executive': 'bg-purple-400',
    'Provisional Executive': 'bg-orange-400',
    'Emerald': 'bg-emerald-400',
    'Diamond': 'bg-cyan-400',
    'Blue Diamond': 'bg-violet-400',
    'Presidential Director': 'bg-amber-400',
  };
  return map[rank] || 'bg-zinc-500';
}

export function getEBRate(gsv: number): number {
  if (gsv >= 50000) return 0.15;
  if (gsv >= 25000) return 0.14;
  if (gsv >= 15000) return 0.13;
  if (gsv >= 10000) return 0.12;
  if (gsv >= 5000) return 0.11;
  if (gsv >= 3000) return 0.10;
  if (gsv >= 2000) return 0.09;
  return 0;
}

export function getEBTierLabel(gsv: number): string {
  if (gsv >= 50000) return '15%';
  if (gsv >= 25000) return '14%';
  if (gsv >= 15000) return '13%';
  if (gsv >= 10000) return '12%';
  if (gsv >= 5000) return '11%';
  if (gsv >= 3000) return '10%';
  if (gsv >= 2000) return '9%';
  return 'N/A';
}

export const GSV_TREND_DATA = [
  { month: 'May', gsv: 58200, activeCount: 16, commissions: 7840 },
  { month: 'Jun', gsv: 61400, activeCount: 17, commissions: 8290 },
  { month: 'Jul', gsv: 59800, activeCount: 16, commissions: 8050 },
  { month: 'Aug', gsv: 63100, activeCount: 18, commissions: 8510 },
  { month: 'Sep', gsv: 65400, activeCount: 18, commissions: 8820 },
  { month: 'Oct', gsv: 62700, activeCount: 17, commissions: 8460 },
  { month: 'Nov', gsv: 67200, activeCount: 19, commissions: 9060 },
  { month: 'Dec', gsv: 71800, activeCount: 20, commissions: 9680 },
  { month: 'Jan', gsv: 66300, activeCount: 18, commissions: 8940 },
  { month: 'Feb', gsv: 64100, activeCount: 17, commissions: 8640 },
  { month: 'Mar', gsv: 69400, activeCount: 19, commissions: 9360 },
  { month: 'Apr', gsv: 68400, activeCount: 19, commissions: 9240 },
];

export const COMMISSION_HISTORY = [
  { month: 'May', retail: 420, l1Bonus: 310, eb: 5238, eeb: 2619, dblg1: 1240, breakaway: 520 },
  { month: 'Jun', retail: 460, l1Bonus: 330, eb: 5526, eeb: 2763, dblg1: 1380, breakaway: 580 },
  { month: 'Jul', retail: 390, l1Bonus: 295, eb: 5382, eeb: 2691, dblg1: 1190, breakaway: 490 },
  { month: 'Aug', retail: 480, l1Bonus: 355, eb: 5679, eeb: 2839, dblg1: 1420, breakaway: 620 },
  { month: 'Sep', retail: 510, l1Bonus: 375, eb: 5886, eeb: 2943, dblg1: 1480, breakaway: 660 },
  { month: 'Oct', retail: 445, l1Bonus: 340, eb: 5643, eeb: 2821, dblg1: 1350, breakaway: 600 },
  { month: 'Nov', retail: 530, l1Bonus: 390, eb: 6048, eeb: 3024, dblg1: 1560, breakaway: 700 },
  { month: 'Dec', retail: 580, l1Bonus: 420, eb: 6462, eeb: 3231, dblg1: 1740, breakaway: 780 },
  { month: 'Jan', retail: 490, l1Bonus: 365, eb: 5967, eeb: 2983, dblg1: 1480, breakaway: 660 },
  { month: 'Feb', retail: 460, l1Bonus: 345, eb: 5769, eeb: 2884, dblg1: 1380, breakaway: 620 },
  { month: 'Mar', retail: 540, l1Bonus: 400, eb: 6246, eeb: 3123, dblg1: 1620, breakaway: 720 },
  { month: 'Apr', retail: 560, l1Bonus: 415, eb: 6156, eeb: 3078, dblg1: 1560, breakaway: 700 },
];

export const GENERATION_DATA = [
  { gen: 'G1', label: 'Generation 1', execCount: 3, gsv: 31200 + 18700 + 1850, bonusPct: 5, bonus: 0, isBreakaway: true },
  { gen: 'G2', label: 'Generation 2', execCount: 5, gsv: 12400 + 5800 + 2100, bonusPct: 5, bonus: 0, isBreakaway: true },
  { gen: 'G3', label: 'Generation 3', execCount: 3, gsv: 4200 + 890 + 490, bonusPct: 5, bonus: 0, isBreakaway: true },
  { gen: 'G4', label: 'Generation 4', execCount: 2, gsv: 680 + 210, bonusPct: 2.5, bonus: 0, isBreakaway: true },
  { gen: 'G5', label: 'Generation 5', execCount: 2, gsv: 390 + 240, bonusPct: 2.5, bonus: 0, isBreakaway: false },
  { gen: 'G6', label: 'Generation 6', execCount: 2, gsv: 260 + 230, bonusPct: 2.5, bonus: 0, isBreakaway: false },
].map(g => ({ ...g, bonus: g.gsv * (g.bonusPct / 100) }));

export const RANK_DISTRIBUTION = [
  { rank: 'Distributor', count: 9, color: '#71717a' },
  { rank: 'Brand Partner Gold', count: 3, color: '#facc15' },
  { rank: 'Brand Partner Lapis', count: 2, color: '#60a5fa' },
  { rank: 'Brand Partner Ruby', count: 1, color: '#f87171' },
  { rank: 'Executive', count: 2, color: '#c084fc' },
  { rank: 'Prov. Executive', count: 1, color: '#fb923c' },
  { rank: 'Emerald', count: 1, color: '#34d399' },
  { rank: 'Diamond', count: 1, color: '#22d3ee' },
  { rank: 'Blue Diamond', count: 1, color: '#a78bfa' },
  { rank: 'Presidential', count: 1, color: '#fbbf24' },
];